import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import businessRelationService from 'services/businessRelationService';
import { RevisionDetail } from 'views/RevisionHistory/RevisionDtos';
import { setDlmStatusAndVersion } from 'reducers/dlmReducer';
import { AxiosError } from 'axios';
import { isNotNullOrUndefined } from 'utils/utils';

export const useFetchBrComparison = (techId: string, oldVersion: number | null, newVersion: number) => {
  const dispatch = useDispatch();

  const query = useQuery<RevisionDetail[], AxiosError>({
    queryKey: ['useFetchBrComparison', techId, oldVersion, newVersion],
    queryFn: () => businessRelationService.getBrComparison(techId, oldVersion, newVersion),
    gcTime: 0,
  });

  const { isError, error } = query;

  useEffect(() => {
    if (isError && isNotNullOrUndefined(error)) {
      dispatch(setDlmStatusAndVersion({ status: 'ACTIVE', version: 1 }));
    }
  }, [query.error, dispatch]);

  return query;
};
